<template>
  <v-app>
    <router-view />
    <confirm-cancel-order-dialog />
  </v-app>
</template>

<script>
import store from '@/shared/store';
import axios from '@/shared/utils/axios-init';
import ConfirmCancelOrderDialog from '@/shared/components/ConfirmCancelOrderDialog';

export default {
  name: 'app',
  components: {
    ConfirmCancelOrderDialog,
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.auth.auth.isAuthenticated;
    },
  },
  created() {
    axios.interceptors.response.use(null, (error) => {
      if (error.response && error.response.status === 401) {
        store.dispatch('auth/auth/logOut');
      }
      return Promise.reject(error);
    });

    this.$store.dispatch('auth/auth/checkUser');
    this.$store.dispatch('global/fetchClockTimestamp');
    this.$store.dispatch('global/fetchLanguagesData');

    const currencies = JSON.parse(localStorage.getItem('currencies'));
    this.$store.commit(
      'dashboard/market/currenciesPairFromLocalStorage',
      localStorage.getItem('currencies')
    );
    this.$store.commit(
      'dashboard/market/setSelectedQuated',
      currencies.quoteCurrency
    );

    this.$store.dispatch('docs/documentation/fetchDocumentationData');
  },
};
</script>

<style lang="scss">
@import 'vuetify/dist/vuetify.min.css';
@import '~@/styles/index';

#app {
  font-family: 'San Francisco', 'Roboto', 'Open Sans', Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue